import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'
import React from 'react'

import { profileRoute } from '../../routes/routes'

const DialogPausedLocation = ({ open }) => {
  const goToSelectLocation = () => {
    window.location.href = profileRoute.path
  }
  return (
    <Dialog open={open}>
      <Box display="flex" justifyContent="center" marginTop={4}>
        <img
          alt="Foodsby"
          src="https://images.foodsby.com/conweb/paused-location.png"
          width="240"
        />
      </Box>
      <DialogTitle>Foodsby Service Update</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Individual lunch deliveries at this location have been temporarily paused in response to
          COVID-19. <a href={process.env.REACT_APP_GROUP_ORDER_URL}>Foodsby Meetings</a>, our group
          lunch ordering platform, is still available at this time. On behalf of everyone here at
          Foodsby, we appreciate your ongoing support and look forward to serving you again soon.
        </DialogContentText>
        <DialogContentText>
          Please reach out to us at <a href="mailto:buildings@foodsby.com">buildings@foodsby.com</a>{' '}
          as soon as you know people are planning to return to your office. Our team is available to
          help resume service in a timely manner.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={goToSelectLocation}>Select A Different Location</Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogPausedLocation
